import React from "react";
import classNames from "classnames";
import { Table as AntTable } from "antd";

export interface TableProps {
  colData?: any;
  rowData?: any;
  rowClassName?: (record, index) => string;
  loading?: boolean;
  paginationSettings?:
    | false
    | {
        total: number;
        pageSize: number;
        current: number;
        showQuickJumper?: boolean;
        showSizeChanger?: boolean;
      };
  setPage?: (val) => void;
  setPageSize?: (val) => void;
  bordered?: boolean;
  className?: string;
  scrollHeight?: number | string;
  scrollWidth?: number | string;
  components?: any;
  onChange?: (sorter) => void;
  locale?: {
    emptyText?: string | React.ReactElement;
  };
}

const Table: React.FC<TableProps> = ({
  className,
  rowData,
  colData,
  rowClassName,
  setPage,
  paginationSettings,
  scrollHeight,
  scrollWidth,
  loading,
  bordered,
  setPageSize,
  components,
  onChange,
  locale,
}) => {
  const handleTableChange = (pagination, filters, sorter) => {
    setPageSize && setPageSize(pagination.pageSize);
    setPage && setPage(pagination.current);
    onChange && onChange(sorter);
  };

  return (
    <div className={classNames("table", className)}>
      <AntTable
        dataSource={rowData}
        columns={colData}
        pagination={paginationSettings}
        bordered={bordered}
        loading={loading}
        rowClassName={rowClassName}
        scroll={{
          y: scrollHeight,
          x: scrollWidth,
        }}
        components={components}
        onChange={handleTableChange}
        locale={locale}
      />
    </div>
  );
};

Table.defaultProps = {
  paginationSettings: false,
};

export default Table;
